export default __webpack_public_path__ + "assets/b9c5b839-db56-4419-8fcb-6ab661babb1d-ext.woff2";